<template>
    <el-popover
        v-model="visible"
        popper-class="saved-notes-popover"
        trigger="click">
        <ul>
            <li v-for="chart in savedCharts" :key="chart.id" @click="$emit('open-notes', chart.id)">
                <div class="edited-on">
                    <img src="./img/save-alternate.svg" />
                    Edited on 
                    <b>{{ formatDate(chart.created) }}, {{ formatTime(chart.created) }}</b>
                </div>
                <div class="last-pushed" v-if="chart.last_push_timestamp">
                    <img src="./img/push.svg" />
                    Last pushed on 
                    <b>{{ formatDate(chart.last_push_timestamp) }}, {{ formatTime(chart.last_push_timestamp) }}</b>
                </div>
                <div class="edited-by">
                    <ProfileIcon class="profile-icon"></ProfileIcon>
                    {{ chart.created_by === 'DoctorPlan' ? 'Created by DoctorPlan' : chart.created_by }}
                </div>
            </li>
        </ul>
        <el-button type="text" slot="reference" style="padding: 0; font-size: 12px;font-weight: 600;">
            Edited <i class="el-icon-arrow-down" :style="iconStyle" />
        </el-button>
    </el-popover>
</template>

<script>
import formatDate from '@/module/util/format-date'
import formatTime from '@/module/util/format-time'

import ProfileIcon from '@/module/dashboard/navbar/icon/Profile.vue'

export default {
    name: 'saved-notes',
    props: {
        savedCharts: {
            type: Array,
            required: true
        },
    },
    data() {
        return {
            visible: false
        }
    },
    methods: {
        formatDate,
        formatTime
    },
    computed: {
        iconStyle() {
            if(this.visible)
                return {
                    transform: 'rotate(180deg)'
                }
            return {}
        }
    },
    components: {
        ProfileIcon
    }
}
</script>

<style lang="scss">
.el-popover.saved-notes-popover {
    width: 400px;
    padding: 0;
    max-height: 500px;
    overflow-y: auto;
    .el-popover__reference {
        font-size: 13px;
        font-weight: 600;
    }
    ul {
        padding: 0;
        margin: 0;
        display: flex;
        flex-direction: column-reverse;
        li {
            border-bottom: 1px solid #ececec;
            list-style: none;
            padding: 20px 16px;
            font-size: 13px;
            cursor: pointer;
            &:hover {
                background: #F8F8F8;
            }
            & > div {
                padding: 3px 0;
                display: flex;
                align-items: center;
                gap: 5px;
            }
            .profile-icon {
                width: 16px;
                height: 16px;
            }
        }
    }
    
}
</style>
